const throw_error = (msg = "An error occurred", status = 400) => {
  throw { msg, status }
}

module.exports = { throw_error }
